module.exports = __webpack_public_path__ + "static/media/saved-searches-empty-state-d.5c93bc89.svg";